import { Link, useParams } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from '@tanstack/react-query';
import Card from 'components/card';
import Button from 'components/button';
import SimpleTable from 'components/simpleTable';
import Header from 'components/text/header';
import { useState } from 'react';
import AdminForm from './adminForm';
import Checkbox from 'components/checkbox';
import UseApi from 'hooks/useApi';
import { HiArrowLeft } from 'react-icons/hi';
import Loader from 'components/loader';

const roles = ['Create', 'Read', 'Update', 'Archive', 'Approve'];

const queryClient = new QueryClient();

const AdminData = () => {
  const { getApi, patchApi, deleteApi } = UseApi();
  const { id } = useParams();

  async function fetchData(id: string) {
    const response = await getApi(`admins/${id}`);
    return response.data;
  }

  const { data, isLoading, error } = useQuery({
    queryKey: ['data', id],
    queryFn: () => fetchData(id),
  });
  const [isFormVisible, setIsFormVisible] = useState(false);
  if (isLoading) return <Loader />;
  if (error) return <Header>An error has occurred: {error.message}</Header>;

  const { username, metadata, permissions } = data;

  const archive = async () => {
    await patchApi(`admins/${id}/metadata`, {
      isArchived: true,
      archivedOn: new Date(),
    });
  };
  const remove = async () => {
    await deleteApi(`admins/${id}`);
  };
  const toggleVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  return (
    <div className="flex flex-col gap-3">
      <Link key={1} to={'/admin/admins'}>
        <Button variant="gray" extraClasses="flex items-center gap-2 ">
          <HiArrowLeft />
          Back
        </Button>
      </Link>
      <Card extra="gap-2 p-4">
        {isFormVisible ? (
          <AdminForm
            type="Update"
            formValues={data}
            onSubmit={toggleVisibility}
          />
        ) : (
          <>
            <SimpleTable
              header="Admin Details"
              data={[{ key: 'Username', value: username }]}
            />
            <div className="ml-4">
              <Header extraClasses="text-2xl font-bold mb-3">
                Permissions
              </Header>
              {permissions.map((permission: any, index: number) => (
                <div key={index}>
                  <Header extraClasses="text-gray-500 text-lg">
                    {permission.module}
                  </Header>
                  <div className="flex gap-5">
                    {roles.map((role) => (
                      <Checkbox
                        label={role}
                        value={role}
                        checked={permission.roles.includes(role)}
                        extra="my-2"
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        <Button extraClasses="m-auto" onClick={toggleVisibility}>
          {isFormVisible ? 'Cancel' : 'Edit'}
        </Button>
        {!metadata?.isArchived && (
          <Button extraClasses="m-auto" onClick={archive} variant="error">
            Archive
          </Button>
        )}
        {/* <Button extraClasses="m-auto" onClick={remove}>
          delete
        </Button> */}
      </Card>
    </div>
  );
};

const AdminDetails = (props: {}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AdminData />
    </QueryClientProvider>
  );
};

export default AdminDetails;
